<template>

    <div class="comment-wrap user">
        <!-- USER AVATAR -->
            <figure class="user-avatar medium">
                <img :src="'/images/avatars/'+comment.user.avatar" alt="">
            </figure>
        <!-- /USER AVATAR -->
        <div class="comment">

            <p v-if="comment.read_at != null" :title="'Read: ' + readAt" class="report tooltip">{{comment.created_at | fromNowAgo}}</p>
            <p v-else class="report">{{comment.created_at | fromNowAgo}}</p>

            <p class="text-header">{{comment.user.name}}</p>
            <!-- PIN -->
            <span class="pin greyed">Refund requested</span>
            <!-- /PIN -->
            <br>

            <div class="quote dispute">
                <p class="text-header small">Dispute comments:</p>
                <p class="message">{{comment.body}}</p>

                <p v-if="comment.files.length > 0" class="text-header">Attached files: </p>
                <div v-if="comment.files.length > 0" v-for="file in comment.files" class="file-name">
                    <a :href="'/files/'+order.hashId+'/'+file.name"></a>
                    <i class="fa fa-arrow-circle-o-down" aria-hidden="true"></i>
                    <a :href="'/files/'+order.hashId+'/'+file.name">{{file.name}}</a>
                </div>
            </div>
        </div>
    </div>

</template>


<script>

    export default {
        props: ['comment', 'order'],
        data() {
            return {

            }
        },

        created(){
        },

        computed: {
            readAt: function () {
                return this.$options.filters.fromNowAgo(this.comment.read_at);
            }
        },

        methods: {
        }

    }
</script>